package com.appsyde.shared.modules.team.data.repository

import com.appsyde.shared.modules.team.data.InviteListItemDto
import com.appsyde.shared.modules.team.data.UserListItemDto
import com.appsyde.shared.modules.team.data.source.CreateInviteResult as DataCreateInviteResult
import com.appsyde.shared.modules.team.data.source.TeamRemoteDataSource
import com.appsyde.shared.modules.team.domain.model.CreateInviteResult
import com.appsyde.shared.modules.team.domain.model.TeamInvite
import com.appsyde.shared.modules.team.domain.model.TeamUser
import com.appsyde.shared.modules.team.domain.repository.TeamRepository

class TeamRepositoryImpl(
    private val remote: TeamRemoteDataSource
) : TeamRepository {

    override suspend fun getUsers(): List<TeamUser> =
        remote.getUsers().map { it.toTeamUser() }

    override suspend fun getInvites(): List<TeamInvite> =
        remote.getInvites().map { it.toTeamInvite() }

    override suspend fun createInvite(email: String): CreateInviteResult =
        when (val dataResult = remote.createInvite(email)) {
            is DataCreateInviteResult.Ok -> CreateInviteResult.Ok(inviteId = dataResult.inviteId)
            is DataCreateInviteResult.InvalidEmail -> CreateInviteResult.InvalidEmail
            is DataCreateInviteResult.CannotInviteOwner -> CreateInviteResult.CannotInviteOwner
            is DataCreateInviteResult.AlreadyMember -> CreateInviteResult.AlreadyMember
            is DataCreateInviteResult.Error -> CreateInviteResult.Error(dataResult.message)
        }

    override suspend fun revokeInvite(inviteId: String): Boolean =
        remote.revokeInvite(inviteId)

    override suspend fun disableUser(userId: String): Boolean =
        remote.disableUser(userId)
}

private fun UserListItemDto.toTeamUser() = TeamUser(
    id = id,
    email = email,
    role = role,
    status = status,
    createdAt = createdAt,
    updatedAt = updatedAt
)

private fun InviteListItemDto.toTeamInvite() = TeamInvite(
    id = id,
    email = email,
    expiresAt = expiresAt,
    usedAt = usedAt,
    revokedAt = revokedAt,
    createdAt = createdAt
)
